// transaction
export const documentType={label:"Document Type",name:"documentType"};
export const documentNo={label:"Document NO.",name:"documentNum"};
export const supplierTin={label:"Supplier's TIN",name:"supplierTin"};
export const supplierName={label:"Supplier's Name",name:"supplierName"};
export const buyerTin={label:"Buyer's TIN",name:"buyerTin"};
export const buyerName={label:"Buyer's Name",name:"buyerName"};
export const startDate={label:"Transaction Date from",name:"dateFrom"};
export const endDate={label:"to",name:"dateTo"};

export const transactionStatus={label:"Transaction Status",name:"transactionStatus"};
export const dataIntegrity={label:"Data Integrity",name:"dataIntegrity"};
export const invoiceIssued={label:"Invoice Issued",name:"invoiceIssued"};
export const invoiceUuid={label:"E-Invoice UUID",name:"invoiceUuid"};
export const documentStatus={label:"Invoice Status",name:"invoiceStatus"};
export const confirmationStatus={label:"Invoice Confirmation Status",name:"confirmStatusCode"};
export const source={label:"Source",name:"sourceCode"};
export const invoiceStartDate={label:"Issued Date from",name:"issuedDateFrom"};
export const invoiceEndDate={label:"to",name:"issuedDateTo"};

export const totalExcludingTax={label:"Total Excluding Tax",name:"totalExcludingTax"};
export const totalIncludingTax={label:"Total Including Tax",name:"totalIncludingTax"};
export const totalPayableAmount={label:"Total Payable Amount",name:"totalPayableAmount"};
export const totalPayableAmountRange={label:"Total Payable Amount Range"};
export const totalTaxAmount={label:"Total Tax Amount",name:"totalTaxAmount"};
export const currency={label:"Currency",name:"currency"};
export const transactionDate={label:"Transaction Date",name:"transactionDate"};
export const dateTimeIssued={label:"Date Time Issued",name:"dateTimeIssued"};
export const submissionUid={label:"Submission UID",name:"submissionUid"};
export const errorInformation={label:"Error Information",name:"errorInformation"};
export const operationTime={label:"Operation Time",name:"operationTime"};
export const uploadTime={label:"Upload Time",name:"uploadTime"};

export const invoiceType={label:"E-Invoice Type",name:"invoiceType"};
export const invoiceCodeNumber={label:"E-Invoice Code Number",name:"invoiceCodeNumber"};
export const h5InvoiceCodeNumber={label:"Receipt Number",name:"invoiceCodeNumber"};
export const h5InvoiceCodeNumber2={label:"Invoice Number",name:"invoiceCodeNumber"};
export const oriInvoiceCodeNumber={label:"Original Invoice Code Number",name:"oriInvoiceCodeNumber"};
export const oriInvoiceUuid={label:"Original Invoice UUID",name:"oriInvoiceUuid"};
export const invoiceCurrency={label:"Invoice Currency",name:"invoiceCurrency"};
export const exchangeRate={label:"Exchange Rate",name:"exchangeRate"};
export const businessSystem={label:"Business System",name:"businessSystem"};
export const storeCode={label:"Store Code/Location",name:"storeCode"};
export const invoiceDateTime={label:"E-Invoice Date Time",name:"invoiceDateTime"};
export const actualDateTime={label:"Actual Date Time",name:"actualDateTime"};
export const K1={label:"K1",name:"K1"};
export const K2={label:"K2",name:"K2"};
export const incoterms={label:"Incoterms",name:"incoterms"};
export const ftaInformation={label:"FTA Information",name:"ftaInformation"};

export const supplierTin1={label:"TIN",name:"supplierTin"};
export const supplierName1={label:"Name",name:"supplierName"};
export const supplierIdType={label:"ID Type",name:"supplierIdType"};
export const supplierIdValue={label:"ID Value",name:"supplierIdValue"};
export const supplierSst={label:"SST Registration Number",name:"supplierSst"};
export const supplierTtx = {label:"Tourism Tax Registration Number",name:"supplierTtx"};
export const supplierContactNum={label:"Contact Number",name:"supplierContactNum"};
export const supplierEmail={label:"E-mail",name:"supplierEmail"};
export const supplierMsicCode={label:"Malaysia Standard Industrial Classification (MSIC) Code",name:"supplierMsicCode"};
export const supplierBusinessDes={label:"Business Activity Description",name:"supplierBusinessDes"};
export const supplierCountryCode={label:"Country",name:"supplierCountryCode"};
export const supplierStateCode={label:"State",name:"supplierStateCode"};
export const supplierCityName={label:"City Name",name:"supplierCityName"};
export const supplierAddressLine0={label:"Address Line 0",name:"supplierAddressLine0"};
export const supplierAddressLine1={label:"Address Line 1",name:"supplierAddressLine1"};
export const supplierAddressLine2={label:"Address Line 2",name:"supplierAddressLine2"};
export const supplierPostalZone={label:"Postal Zone",name:"supplierPostalZone"};
export const authorisationNumberforCertifiedExporter={label:"Authorisation Number For Certified Exporter",name:"authorisationNumberforCertifiedExporter"};
export const customerServiceEmail={label:"Customer Service Email",name:"customerServiceEmail"};

export const operationDateFrom={label:"Operation Date from",name:"operationDateFrom"};
export const operationDateTo={label:"to",name:"operationDateTo"};
export const operator={label:"Operator", name: "operator"};
export const enableBusinessSystem={label:"Whether to enable business system permissions or not",name:"Business System"};


export const buyerTin1={label:"TIN",name:"buyerTin"};
export const h5BuyerTin={label:"Tax Identification No. (TIN)",name:"buyerTin"};
export const buyerName1={label:"Name",name:"buyerName"};
export const buyerIdType={label:"ID Type",name:"buyerIdType"};
export const buyerIdValue={label:"ID Value",name:"buyerIdValue"};
export const buyerSst={label:"SST Registration Number",name:"buyerSst"};
export const buyerContactNum={label:"Contact Number",name:"buyerContactNum"};
export const buyerEmail={label:"E-mail",name:"buyerEmail"};
export const buyerMsicCode={label:"Malaysia Standard Industrial Classification (MSIC) Code",name:"buyerMsicCode"};
export const buyerCode={label:"Buyer Code",name:"buyerCode"};
export const buyerCountryCode={label:"Country",name:"buyerCountryCode"};
export const buyerStateCode={label:"State",name:"buyerStateCode"};
export const buyerCityName={label:"City Name",name:"buyerCityName"};
export const buyerAddressLine0={label:"Address Line 0",name:"buyerAddressLine0"};
export const buyerAddressLine1={label:"Address Line 1",name:"buyerAddressLine1"};
export const buyerAddressLine2={label:"Address Line 2",name:"buyerAddressLine2"};
export const buyerPostalZone={label:"Postal Zone",name:"buyerPostalZone"};
export const buyerAddressLine={label:"Address Line",name:"buyerAddressLine0"};

export const classification={label:"Classification",name:"classification"};
export const itemName={label:"Item Name",name:"itemName"};
export const itemCode={label:"Item Code",name:"itemCode"};
export const measurement={label:"Measurement",name:"measurement"};
export const quantity={label:"Quantity",name:"quantity"};
export const unitPrice={label:"Unit Price",name:"unitPrice"};
export const totalBeforeDiscount={label:"Total Before Discount",name:"totalBeforeDiscount"};
export const taxAmount={label:"Tax Amount",name:"taxAmount"};
export const subtotal={label:"Subtotal",name:"subtotal"};
export const discountRate={label:"Discount Rate",name:"discountRate"};
export const discountAmount={label:"Discount Amount",name:"discountAmount"};
export const discountReason={label:"Discount Reason",name:"discountReason"};
export const feeChargeRate={label:"Fee/Charge Rate",name:"feeChargeRate"};
export const feeChargeAmount={label:"Fee/Charge Amount",name:"feeChargeAmount"};
export const feeChargeReason={label:"Fee/Charge Reason",name:"feeChargeReason"};
export const productTariffCode={label:"Product Tariff Code",name:"productTariffCode"};
export const countryOfOrigin={label:"Country of Origin",name:"countryOfOrigin"};


export const paymentMode={label:"Payment Mode",name:"paymentMode"};
export const supplierBankAccountNumber={label:"Supplier's Bank Account Number",name:"supplierBankAccountNumber"};
export const paymentTerms={label:"Payment Terms",name:"paymentTerms"};
export const prePaymentAmount={label:"PrePayment Amount",name:"prePaymentAmount"};
export const prePaymentDateTime={label:"PrePayment Date Time",name:"prePaymentDateTime"};
export const prePaymentReferenceNumber={label:"PrePayment Reference Number",name:"prePaymentReferenceNumber"};
export const billReferenceNumber={label:"Bill Reference Number",name:"billReferenceNumber"};

export const taxType={label:"Tax Type",name:"taxType"};
export const taxRate={label:"Tax Rate",name:"taxRate"};
export const perUnitAmount={label:"PerUnit Amount",name:"perUnitAmount"};
export const netAmount={label:"Net Amount",name:"netAmount"};

export const totalNetAmount={label:"Total Net Amount",name:"totalNetAmount"};
export const totalDiscountValue={label:"Total Discount Value",name:"totalDiscountValue"};
export const totalFeeChargeAmount={label:"Total Fee/Charge Amount",name:"totalFeeChargeAmount"};
export const roundingAmount={label:"Rounding Amount",name:"roundingAmount"};

export const issuerTin={label:"Issuer TIN",name:"belongTin"};
export const productDes={label:"Description of Product or Service",name:"productDes"};
export const rejectionReason={label:"Reason for Rejection",name:"rejectionReason"};
export const cancellationReason={label:"Reason for Cancellation",name:"cancellationReason"};
export const totalAmount={label:"Total Amount",name:"totalAmount"};
export const buyerType={label:"Buyer Type",name:"buyerType"};
export const captcha ={label:"Captcha"};

export const submissionDateFrom = {label:"Submission Date from"};
export const issueDateFrom = {label:"Issued Date from"};
export const totalSales={label:"Total Sales"};
export const totalDiscount={label:"Total Discount"};
export const total={label:"Total",name:"cancellationReason"};
export const totalOriginalSales={label:"Total Original Sales"};
export const totalOriginalDiscount={label:"Total Original Discount"};
export const netOriginalAmount={label:"Net Original Amount"};
export const totalOriginal={label:"Total Original"};
export const cancelDateTime={label:"Cancel Date Time"};
export const rejectRequestDate={label:"Reject Request Date Time"};
export const documentStatusReason={label:"Document Status Reason"};
export const createdByUserId={label:"Created By UserId"};

export const invoicePeriod={label:"Invoice Period"};
export const invoicePeriodFrom={label:"Invoice Period from"};
export const invoicePeriodTo={label:"Invoice Period to"};
export const consolidatedPeriod={label:"Consolidated Period"};
export const billingFrequency={label:"Frequency of Billing"};

export const transactionSectionA="Section A: Basic Information";
export const transactionSectionB="Section B: Supplier’s Information";
export const transactionSectionC="Section C: Buyer's Details";
export const transactionSectionD="Section D: Line Item Details";
export const transactionSectionE="Section E: Payment Details";
export const transactionSectionF="Section F: Tax Details";
export const transactionSectionG="Section G: Additional Charge";
export const transactionSectionH="Section H: Summary";

export const transactionAddress="Address";
export const modifyIssue ="Modify & Issue";
export const batchSubmit ="Batch Submit";
export const issue ="Issue";
export const invoiceIssuance="Invoice Issuance";
export const invoiceDetails="Invoice Details";
export const orderDetails="Order's Details";

export const cancelReasons="Cancellation Reasons";
export const rejectReasons="Rejection Reasons";

export const transactionTin={label:"Transaction TIN", name: "tin"};
export const uploadConfirmTip={label:"Are you sure you want to upload?"};
export const selectOneTip={label:"Please select a document to upload."};

export const uploadTemplate="Upload Template";
export const uploadedRecords="Uploaded Records";
export const templateUploadDetails={label:"Upload Details", name: "uploadDetails"};
export const templateUploadTime={label:"Upload Time", name: "createTime"};
export const templateUploadTimeFrom={label:"Upload Time from"};
export const templateUploadTimeTo={label:"to"};
export const templateOperator={label:"Operator", name: "createUserName"};
export const referenceNo={label:"Reference No.", name: "referenceNo"};
export const fileName={label:"File Name", name: "fileName"};
export const uploadStatus={label:"Upload Status", name: "uploadStatus"};
export const totalQuantity={label:"Total Quantity", name: "totalQuantity"};
export const templateSource={label:"Source", name: "source"};
export const incompletedFields={label:"Incompleted Fields", name: "incompletedFields"};
export const shareInvoicePdfTip="Are you sure you want to send?";

export const cannotCancelAgain="Invoices in cancelled status cannot be cancelled again. Please check the selected data.";
export const cannotCancelExpired="Cancellation cannot be made after 72 hours. Please check the selected data.";
export const rejectCancelledFail="Invoices in cancelled status cannot be rejected. Please check the selected data.";
export const rejectWaitingFail="Only invoices in waiting status can be selected for rejection. Please check the selected data.";
export const rejectedRepeat="The invoice has been rejected.";
export const rejectWaitingHours="Rejection cannot be made after 72 hours. Please check the selected data.";
export const cannotCancelOtherStatus="Only valid invoices can be cancelled, please check the selected data.";

export const voidContent="Are you sure you want to void the data ?";
export const voidDis="This transaction has been voided.";
export const voidIssue="This transaction has already been issued an e-Invoice and cannot be voided.";
export const invalidReasons="Invalid Reasons";
export const operationDetails="Operation Details";
export const viewInvalidReasons="View Invalid Reasons";
export const viewTransactionInvalidReasonsTip="Please select a transaction data that has failed validation or has an invalid invoice status.";
export const viewInvoiceInvalidReasonsTip="Please select an invoice with an invalid status.";
export const notSameBuyerTin="The buyer TIN is inconsistent with the selected TIN, please modify it.";
export const notSameSupplierTin="The supplier TIN is inconsistent with the selected TIN, please modify it.";
export const pdfViewOrShareTip="Please select an invoice with a valid status.";
export const uploadSuffixLimit="The uploaded file must be in the following format: .xlsx, .xls, .csv.";
export const uploadFileSizeLimit="The maximum file upload limit is 10M.";
export const detailsOfTaxExemption="Details of Tax Exemption";
export const invoicingConsolidatedTip="Are you sure you want to proceed with invoicing consolidated?";
export const consolidatedInvoiceNotAvailableTip="The consolidated invoice is not available.";

// invoice
export const invalidReasonStr="TIN and identity type combination is invalid";
export const invoicePdfStyle={label:"Invoice PDF Style",name:"invoicePdfStyle"};

export const uuid={label:"UUID"};
export const longId={label:"Long ID"};
export const internalId={label:"Internal ID"};
export const typeName={label:"Type Name"};
export const typeVersionName={label:"Type Version Name"};
export const issuerName={label:"Issuer Name"};
export const receiverId={label:"Receiver ID"};
export const receiverName={label:"Receiver Name"};
export const dateTimeReceived={label:"Date Time Received"};
export const dateTimeValidated={label:"Date Time Validated"};
export const submissionChannel={label:"Submission Channel"};
export const intermediaryName={label:"Intermediary Name"};
export const intermediaryTIN={label:"Intermediary TIN"};
export const searchQuery={label:"Search Query"};
export const status={label:"Status"};
export const applicableType={label:"Applicable Type",name:"applicableType"};
//addition Charge
export const additionType={label:"Additional Type",name:"additionTypeCode"};
export const additionAmount={label:"Additional Charge Amount",name:"additionAmount"};
export const additionReason={label:"Additional Charge Reason",name:"additionReason"};
export const invalidPaymentModeStr ="Please select a payment mode.";
export const onlyStoreCode = {label:"Store Code",name:"storeCode"};
export const billNo = {label:"Bill Number",name:"billNo"};

//consolidate task
export const serialNumber={label:"Monthly Task Serial Number",name:"serialNumber"};
export const taskDocumentTypeCode={label:"Document Type",name:"taskDocumentTypeCode"};
export const invoicePeriodStr={label:"Invoice Period",name:"invoicePeriodStr"};
export const taskStartTimeStr={label:"Task Start Time",name:"taskStartTimeStr"};
export const taskEndTimeStr={label:"Task End Time",name:"taskEndTimeStr"};
export const taskTypeCode={label:"Task Type",name:"taskTypeCode"};
export const failureReasons={label:"Failure Reasons",name:"failureReasons"};


export const validationResult={label:"Validation Result",name:"validationResult"};

export const NoPermission="The TIN does not have this permission.";
export const tinNoPermission="The TIN to which the data belongs does not have this permission.";
export const dataHasIssued="This transaction has already been issued an e-Invoice and cannot be modified.";
export const dataHasVoided="This transaction has been voided and cannot be issued.";
export const dataHasArchived="Archived data cannot be modified, voided, or invoiced.";
export const dataStatusError="The data you have selected has been invoiced, voided, or incomplete.";
export const batchSubmitTransactionPartFail1=" transactions were successfully submitted, while ";
export const batchSubmitTransactionPartFail2=" transactions failed to be submitted .Among them, ";
export const batchSubmitTransactionPartFail3=" failed to submit due to duplicate submissions.";
export const batchSubmitTransactionAllFail1=" transactions were successfully submitted, while ";
export const batchSubmitTransactionAllFail2=" transactions failed to be submitted.";
export const batchSubmitTransactionSuccess="All transactions have been successfully submitted.";
export const dataHasArchivedAdjustDate="Some of the data you queried has been archived. Please adjust the date range filter to the same month.";
export const issueInvoicesInBulk="Are you sure to issue invoices in bulk?";

export const dataNotEarlierOri="The date and time of the invoice submitted this time cannot be earlier than the original invoice, please modify it.";
export const generatedTransactionData="Before invoicing, a transaction data will be generated for the e-Invoice code number.";
export const invoiceNumberExists="The e-Invoice code number already exists.";
export const transactionExistsBringOut="The transaction already exists, and the e-Invoice code number cannot be modified after the transaction data is brought out on the page. Are you sure you want to bring out the transaction data?";
export const transactionHasInvoiced="The e-Invoice code number has been invoiced.";
export const totalTaxAmountCanOnlyBeZero="The total tax amount can only be zero.";
export const productItemsCannotExceed100Lines="The product items cannot exceed 100 lines!";
export const creditNoteCannotExceedOriginalInvoice="The total amount of the credit note cannot exceed the original invoice.";
export const fillProductInfo="Please fill in the product information.";
export const fillTaxInfo="Please fill in the tax information.";
export const totalNetAmountOutOfLimit="Data exception, total net amount out of limit.";
export const totalExcludingTaxOutOfLimit="Data exception, Total Excluding Tax out of limit.";
export const totalTaxAmountOutOfLimit="Data exception, Total Tax Amount out of limit.";
export const totalIncludingTaxOutOfLimit="Data exception, Total Including Tax out of limit.";
export const totalPayableAmountOutOfLimit="Data exception, Total Payable Amount out of limit.";
export const requestAddressIncorrect="Request address incorrect.";
export const submitSuccessCheckEmail="Successfully submitted. Please check your provided email for validated E-Invoice.";
export const transactionInfoIncomplete="The transaction information is incomplete, details: \r\n";
export const storeCodeBillExceed="E-invoice Date, Store code combined with bill no cannot exceed 50.";
export const storeCodeBillExceed2="Store code combined with bill no cannot exceed 50."
export const invoiceDate={label:"E-Invoice Date"};
export const invoiceCancelled=" invoices have been successfully cancelled.";
export const insufficienRemainLimit="Insufficient of remaining transaction limit.";
export const exchangeRateIsRequired="Exchange Rate is required.";
export const provideProductLine="Please provide tax information for the product line.";
export const provideTaxInfo="Please provide complete tax information first.";
export const fillBuyerTin="Please fill in the buyer's TIN first.";
export const fillSellerTin="Please fill in the seller's TIN first.";
export const selectTinFirst="Please select the transaction TIN first.";
export const submitSuccessCheckResultLater="Submitted successfully, please check the upload result in the upload record later.";
export const downloadTheFiles1="You can only download the files within ";
export const downloadTheFiles2=" days after uploading."
export const selectDataFailedUpload="Please select a data that failed to upload.";
export const fileNotExist="The file does not exist and cannot be downloaded.";
export const contactDisabled="The contact has been disabled and cannot be selected.";
export const productDisabled="The product has been disabled and cannot be selected.";
export const operatedAccount="Operated Account";
export const creditNoteList="Credit Note List";
export const debitNoteList="Debit Note List";
export const refundNoteList="Refund Note List";
export const invoiceQRCodeList="Invoice QRCode List";
export const invoiceList="Invoice List";
export const transactionDataList="Transaction Data List";
export const selectDataTip="Please select a data with a failed or partially successful status.";
export const consolidateTaskList="Consolidate Task List";
export const runConsolidateTask="Run Consolidate Task";
export const viewFailureReasons="View Failure Reasons";
export const monthTaskSubmitSuccess="Submitted successfully! Please check the results in the transaction consolidated task list later.";
export const mergingTaskInProgressTip="There are currently merging tasks in progress, please try again later.";
export const dataHasBeenInvoiced="The data you have selected has been invoiced.";
export const consolidatedSuccessTip="All consolidated transactions have been successfully submitted.";
export const consolidatedFailedTip="All consolidated transactions have failed to be submitted.";
export const consolidatedPartialSuccessTip1="consolidated transactions were successfully submitted, while";
export const consolidatedPartialSuccessTip2=" failed to be submitted. Among them,";
export const consolidatedPartialSuccessTip3=" failed to submit due to duplicate submissions.";
export const consolidatedPartialSuccessTip4="consolidated transactions were successfully submitted, while";
export const consolidatedPartialSuccessTip5="failed to be submitted.";
export const selectTransNotInvoiced="Please select a transaction data that has not been invoiced.";
export const transactionIsComplete="The transaction is complete.";
export const consolidatedTransactionList="Consolidated Transaction List";
export const consolidatedInvoiceTip="Are you sure you want to proceed with invoicing consolidated?";
export const checkIncompletedTip="Check Incompleted Fields";
export const taxAmountOutOfLimit="Data exception, Tax Amount out of limit.";
export const customsNumFormatTip="Can only be letters,numbers,commas.";
export const informationMustBeMaintained="The basic information of the taxpayer has not been maintained.";
export const changeTin="This TIN is retrieved from the IRB site. Are you sure you want to change it?";
export const unitPriceOutOfLimit="Data exception, quantity or unit price out of limit.";
export const quantityOutOfLimit="Data exception, the quantity multiplied by the unit price out of limit.";
export const fillInTaxTip="Please fill in the tax information of the product first.";
export const feeChargeAmountOutOfLimit="Data exception, Fee/Charge Amount out of limit.";
export const discountAmountOutOfLimit="Data exception, Discount Amount out of limit.";
export const subtotalOutOfLimit="Data exception, Subtotal out of limit.";
export const reasonTip="The Reason is:";
export const cancelInvoiceTip1=" invoices have been successfully cancelled, while";
export const cancelInvoiceTip2=" invoices have failed to be cancelled.";
export const additionalDetails="Additional Details";
export const purchaseExport="My Purchase Invoices List";
export const taxDetails="Tax Details";
export const transactionDetailsTemplateTip="The transaction details can only be imported by batch using this template.";
export const sendEmailTip="The invoice will be sent to this email address.";
export const originalNumberOrUUIDisRequired="Original Invoice Code Number and Original Invoice UUID cannot both be empty.";
export const rangeCheckTip="The starting value cannot be greater than the ending value.";
